import { defineMessages } from 'react-intl';

export default defineMessages({
  number: {
    id: 'app.containers.Checklist.ExternalArea.HouseAddress.number',
    defaultMessage: 'Número',
  },
  neighborhood: {
    id: 'app.containers.Checklist.ExternalArea.HouseAddress.neighborhood',
    defaultMessage: 'Bairro',
  },
  floor: {
    id: 'app.containers.Checklist.ExternalArea.HouseAddress.floor',
    defaultMessage: 'Andar',
  },
  address: {
    id: 'app.containers.Checklist.ExternalArea.HouseAddress.address',
    defaultMessage: 'Endereço',
  },
  condoName: {
    id: 'app.containers.Checklist.ExternalArea.HouseAddress.condoName',
    defaultMessage: 'Condomínio (opcional)',
  },
  complement: {
    id: 'app.containers.Checklist.ExternalArea.HouseAddress.complement',
    defaultMessage: 'Complemento',
  },
  houseId: {
    id: 'app.containers.Checklist.ExternalArea.HouseAddress.houseId',
    defaultMessage: 'Cód. Imóvel {houseId}',
  },
});
